// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ButtonBarEl} from 'common/components/button-bar';
import {SelectEl} from 'common/components/select';

import type {FilterBarSimpleFilter} from './index';

export function template(this: FilterBarSimpleFilter) {
  return (
    <SelectEl
      attrs={this.helpers.getSelectAttrs()}
      params={{
        sections: this.params.sections,
      }}
      class={{[`filter-${this.attr(`name`)}`]: true}}
      on={{
        change: (ev: CustomEvent) => this.helpers.handleFilterChange(ev),
        menuChange: (ev: CustomEvent) => this.helpers.handleMenuChange(ev),
      }}
    >
      {this.attr(`apply-button`) ? (
        <ButtonBarEl
          sel='.mp-button-bar-primary'
          attrs={{
            role: `button`,
            tabindex: 0,
            elref: `applyFilterButton`,
            slot: `footer`,
          }}
          on={{
            click: () => this.helpers.handleApplyFilterClick(),
          }}
        >
          {this.attr(`apply-button`)}
        </ButtonBarEl>
      ) : null}
    </SelectEl>
  );
}
